import CartLineItem from './cart-line-item-view'

export default CartLineItem
